import { Component, OnInit } from '@angular/core';
import { Icons } from 'src/app/models/icons.model';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-admin-header',
  standalone: false,
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss'],
})
export class AdminHeaderComponent {
  navCollapsed: boolean = true;
  icons = new Icons();

  constructor(public adminService: AdminService) { }

  toggleNav() {
    this.navCollapsed = !this.navCollapsed;
  }

  closeNav() {
    this.navCollapsed = true;
  }

  refreshData() {
    this.adminService.reloadService();
  }
}
